import React, { FunctionComponent, useState } from 'react'
import { Badge, Button, Layout, Menu, MenuProps, Typography } from 'antd'
import {
  AlertOutlined, CompassOutlined,
  LockOutlined,
  MenuOutlined,
  TagOutlined,
  UnorderedListOutlined
} from '@ant-design/icons'
import { css } from '@emotion/react'
import { backgroundColor } from '../../../../theme'
import AccessManagerModal from '../AccessManagerModal/AccessManagerModal'
import { useLoaderData, useMatch } from '@tanstack/react-router'
import { orange } from '@ant-design/colors'
import { useQuery } from '@tanstack/react-query'
import { useFeathersClient } from '@strac/react-client-feathers'
import useQueryListener from '../../../../hooks/data/useQueryListener'

const { Sider } = Layout

type MenuItem = Required<MenuProps>['items'][number]

interface IProps {
  selectedKey: string | undefined
  setSelectedKey: (value: string | undefined) => void
}

const AccessManagerMenu: FunctionComponent<any> = (props: IProps) => {
  const { setSelectedKey, selectedKey } = props

  const match = useMatch({ strict: false })
  const { assettrakAccess } = useLoaderData({
    from: match.routeId ?? '/'
  })

  const client = useFeathersClient()

  const [collapsed, setCollapsed] = useState<boolean>(true)

  const [open, setOpen] = useState<boolean>(false)

  const geofenceQuery = {
    user_id: assettrakAccess.id,
    active: true,
    $limit: 0
  }
  const {
    data: geofenceCount,
    refetch: refetchGeofenceCount
  } = useQuery({
    queryKey: ['geofence', 'find', geofenceQuery],
    queryFn: () => client.service('geofence').find({
      query: geofenceQuery
    }).then((response: any) => response.total),
    placeholderData: 0
  })

  useQueryListener('geofence', refetchGeofenceCount)

  const items: MenuItem[] = [
    {
      key: 'devices',
      icon: <UnorderedListOutlined />,
      label: 'Devices',
      style: {
        backgroundColor: backgroundColor,
        color: selectedKey === 'devices' ? orange[5] : ''
      }
    },
    {
      key: 'collections',
      icon: <TagOutlined />,
      label: `Collections`,
      style: {
        backgroundColor: backgroundColor,
        color: selectedKey === 'collections' ? orange[5] : ''
      }
    },
    {
      key: 'edit-agencies',
      icon: <LockOutlined />,
      label: 'Access',
      style: {
        backgroundColor: backgroundColor,
        color: open ? orange[5] : ''
      }
    },
    {
      type: 'divider'
    },
    {
      key: 'geofences',
      icon: <Badge offset={[5, 6]} count={geofenceCount} dot={!collapsed} size={'small'}><AlertOutlined /></Badge>,
      label: 'Geofences',
      style: {
        backgroundColor: backgroundColor,
        color: selectedKey === 'geofences' ? orange[5] : ''
      }
    }/*,
    {
      key: 'directions',
      icon: <CompassOutlined />,
      label: 'Directions',
      style: {
        backgroundColor: backgroundColor,
        color: selectedKey === 'directions' ? orange[5] : ''
      }
    },*/
  ]

  const onClick = (e: any) => {
    const { key } = e
    if (key === 'collapse') {
      setCollapsed(!collapsed)
    } else if (key === 'edit-agencies') {
      setSelectedKey(undefined)
      setOpen(true)
    } else {
      setSelectedKey(selectedKey === key ? undefined : key)
    }
  }

  return (
    <Sider collapsed={collapsed}>
      <div
        id={'menu-logo'}
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: collapsed ? 'center' : 'space-evenly',
          alignItems: 'center',
          padding: '10px'
        }}
      >
        {collapsed ? null : <Typography.Text ellipsis={true}>{assettrakAccess.access_code}</Typography.Text>}
        <Button size={'large'} icon={<MenuOutlined />} onClick={() => setCollapsed(!collapsed)} />
      </div>
      <Menu
        onClick={onClick}
        css={css`
          background-color: ${backgroundColor};
        `}
        items={items}
        mode={'inline'}
        theme={'dark'}
      />
      <AccessManagerModal open={open} setOpen={setOpen} assettrakAccess={assettrakAccess} />
    </Sider>
  )
}

export default AccessManagerMenu
